// extracted by mini-css-extract-plugin
export default {"rating":"wJ-z","numberOfStars":"xJ-z","count":"yJ-z","barGraphSpacing":"zJ-z","barGraph":"AJ-z"};